// extracted by mini-css-extract-plugin
export default {"card":"StatItem_card_zK_qI","button":"StatItem_button_k50o0","title":"StatItem_title_m6MPn","icon":"StatItem_icon_hVGD2"};